import * as React from 'react';

import {CTABannerWithButtons} from 'shells/cta-banner/cta-banner-with-buttons';

import {useUpdateSetting} from '../../../core/use-update-setting';
import {OnboardingChecklist} from '../../../onboarding/onboarding-checklist/onboarding-checklist';

import {analyticsClient} from '../../../../analytics-client';

import {CTABannerDemio} from './demio/cta-banner-demio';
import {
    getNonDemioBanners,
    getDemioBanners,
    getRegistrationUrlFromCTABanner,
    getImageInfoFromCTAKey,
    getButtonTextFromCTAKey,
    getAnalyticsEventNameFromCTAKey,
} from './helpers';
import {useGetCTABanners} from './use-get-cta-banners';

import styles from './dashboard-cta-cards.module.css';

type Props = {
    isNarrow: boolean;
    isTiny: boolean;
};

export function DashboardCTACards(props: Props) {
    const {ctaBanners, refetch: refetchBanners} = useGetCTABanners();

    const updateSetting = useUpdateSetting();

    const handleRemoveBanner = (settingName: string, shouldRefetch: boolean) => {
        updateSetting({
            settingName,
            value: '1',
        }).then(() => {
            if (shouldRefetch) {
                refetchBanners();
            }
        });
    };

    return (
        <div className={styles['dashboard-cards-container']}>
            <OnboardingChecklist />
            {getNonDemioBanners(ctaBanners).map((banner) => (
                <CTABannerWithButtons
                    key={banner.title}
                    image={getImageInfoFromCTAKey(banner.key)}
                    title={banner.title}
                    text={banner.subtitle}
                    primaryCTA={{
                        text: getButtonTextFromCTAKey(banner.key),
                        newTab: true,
                        ...getRegistrationUrlFromCTABanner(banner),
                        onClick: () => {
                            const eventName = getAnalyticsEventNameFromCTAKey(banner.key);
                            if (eventName) {
                                analyticsClient.track(eventName);
                            }

                            // Hide banner (but don't refetch), so that
                            // next time page is visited banner is gone
                            handleRemoveBanner(banner.dismissSettingName, false);
                        },
                    }}
                    onDismiss={() => {
                        handleRemoveBanner(banner.dismissSettingName, true);
                    }}
                    includeImage={!props.isNarrow}
                    includeBody={!props.isTiny}
                    includeRemoveButton={!props.isTiny}
                />
            ))}
            {getDemioBanners(ctaBanners).map((banner) => (
                <CTABannerDemio
                    key={banner.demioEvent.id}
                    title={banner.demioEvent.name}
                    subtitle={banner.subtitle}
                    image={getImageInfoFromCTAKey(banner.key)}
                    demioEvent={banner.demioEvent}
                    upcomingEvents={banner.upcomingEvents}
                    onDismiss={() => {
                        handleRemoveBanner(banner.dismissSettingName, true);
                    }}
                    includeImage={!props.isNarrow}
                    includeBody={!props.isTiny}
                    includeRemoveButton={
                        !props.isTiny && !(banner.key === 'LIVE_DEMO' && NutClientConfig.isTrial)
                    }
                    fullSizeImage={banner.key === 'LIVE_DEMO'}
                />
            ))}
        </div>
    );
}
